export const kubernetesLiveResourceHealthStatusCodes = ["Degraded", "Healthy", "Available", "Progressing", "Unknown", "Missing", "Suspended", "Stale"] as const;
export type KubernetesLiveResourceHealthStatusCode = (typeof kubernetesLiveResourceHealthStatusCodes)[number];

export const kubernetesLiveResourceSyncStatusCodes = ["InSync", "OutOfSync", "GitDrift", "Unknown", "NotApplicable", "Waiting", "Unavailable"] as const;
export type KubernetesLiveResourceSyncStatusCode = (typeof kubernetesLiveResourceSyncStatusCodes)[number];
